import { MainImages } from '@lemon/assets';
import { ImageList } from '../../common/Image';

export const Brand = () => {
    return (
        <figure
            className="relative w-full h-full xl:min-h-[1080px] flex flex-col items-start text-left justify-center bg-white text-black
		  px-6 py-10 gap-5 md:px-16 md:py-20 md:gap-10 xl:px-32 xl:py-[132px]"
        >
            <h2 className="text-[40px] md:text-[80px] font-bold font-montserrat leading-[100%] text-primary-black">
                Brand
            </h2>

            <h6 className="text-[18px] md:text-2xl font-bold text-left w-full">{title}</h6>
            <div className="flex flex-col gap-3 md:gap-4 text-[14px] md:text-[20px] lg:text-[24px] text-pretty leading-relaxed max-w-[1000px] w-full">
                <p>{description1}</p>
                <p>{description2}</p>
                <p>{description3}</p>
            </div>

            <ImageList images={images} />
        </figure>
    );
};

const title = '데이터 기반 인사이트와 마케팅';
const description1 = `실제 사용자 파우치 데이터를 기반으로 정교한 인사이트를 확보할 수 있습니다.`;
const description2 = `이를 통해 제품을 타깃 고객에게 효과적으로 노출하고,`;
const description3 = `추천 기능을 활용한 효율적인 마케팅과 고객 확보가 가능합니다.`;

const images = [MainImages.brand_l, MainImages.brand_r];
